import React, { Component } from "react";
import Button from "./../Button/Button";

export default class TextBlock extends Component {
  render() {
    const title = this.props.title;
    const subtitle = this.props.subtitle;
    const children = this.props.children;
    const hasButton = this.props.hasButton;
    const buttonText = this.props.buttonText;
    const buttonLink = this.props.buttonLink;

    return (
      <div
        className={
          "textblock" +
          (this.props.extraClasses ? " " + this.props.extraClasses : "")
        }
        id={this.props.id ? this.props.id : ""}
      >
        {title && <h2>{this.props.title}</h2>}
        {subtitle && <h3>{this.props.subtitle}</h3>}
        {children && <p>{this.props.children}</p>}
        {hasButton && (
          <Button className="btn" to={buttonLink}>
            {buttonText}
          </Button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TextBlock/TextBlock.jsx